import { render, staticRenderFns } from "./fccGestaoArquivosBranding.vue?vue&type=template&id=b6139d84"
import script from "./fccGestaoArquivosBranding.vue?vue&type=script&lang=js"
export * from "./fccGestaoArquivosBranding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports